import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radarCloudsRainIcon",
  "use": "icon-radarCloudsRainIcon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-radarCloudsRainIcon\"><path d=\"M14.352 10.4a3.6 3.6 0 0 1-7.2 0c0-2.588 3.6-8.4 3.6-8.4s3.6 5.812 3.6 8.4ZM5.952 6.2a1.8 1.8 0 0 1-3.6 0c0-1.294 1.8-4.2 1.8-4.2s1.8 2.906 1.8 4.2Z\" stroke=\"#4C556C\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol